import React, { useEffect } from 'react';
import Hint from '../../components/Hint';
import Input from './Input';
import BranchCode from './BranchCode';
const SectionItem = ({
	hint,
	label,
	id,
	parentId,
	rule,
	body,
	type,
	parentIndex,
	setBody,
	errors,
	required,
	sectionIndex,
	edit,
	params,
	leadId,
	selectedLender,
	setErrors
}) => {
	if (id === 'lead_state' || id === 'lead_city') return '';
	if (id === 'lead_zipcode') {
		return (
			<BranchCode
				label={label}
				sectionIndex={sectionIndex}
				required={required}
				parentIndex={parentIndex}
				type={type}
				id={id}
				rule={rule}
				body={body}
				// label={label}
				parentId={parentId}
				setBody={setBody}
				params={params}
				errors={errors}
				edit={edit}
				leadId={leadId}
			/>
		);
	}
	return (
		<div className='col-md-4' style={{'display': rule?.display}}>
			<div className='form-group'>
				<label style={{minHeight: '14px'}}>
					{label} {required == '1' && <tt>*</tt>} <Hint text={hint} id={id} place={'bottom'} />
				</label>
				<Input
					sectionIndex={sectionIndex}
					required={required}
					parentIndex={parentIndex}
					type={type}
					id={id}
					rule={rule}
					body={body}
					label={label}
					parentId={parentId}
					setBody={setBody}
					params={params}
					errors={errors}
					edit={edit}
					leadId={leadId}
					selectedLender={selectedLender}
					setErrors={setErrors}
				/>
			</div>
		</div>
	);
};

export default SectionItem;
